<style lang="scss" scoped>
@screen mobile {
  .history {
    &-entry {
      &__left {
        &-datetime {
          @apply text-base mb-1;
        }
      }
      &__right {
        @apply justify-end;
        &-icon {
          @apply w-4 mr-2;
        }
        &-wrapper {
          @apply flex-none;
        }
      }
    }
  }
}
</style>

<template>
  <main>
    <printTemplate
      :active.sync="modalActive"
      :type="'receipt'"
      @cancel="modalActive = null"
      v-if="modalActive != null"
    />

    <transition name="fade">
      <receipt
        v-if="showReceipt"
        @print="modalActive = $event.receipt"
        @close="showReceipt = false"
        :agendaId="selectedAgenda.id"
      />

      <ul class="history" v-else>
        <li
          v-for="(historyEntry) in historyEntries"
          :key="historyEntry.id"
          class="history-entry"
        >
          <ul class="history-entry__wrapper">
            <li class="history-entry__left">
              <span class="history-entry__left-datetime">
                {{ historyEntry.date | TO_HOUR_MINUTE }}
              </span>

              <div class="history-entry__left-type">
                {{ historyEntry.type }} com

                <strong v-if="!!historyEntry.special_patient !== !!null">
                  {{ historyEntry.special_patient.name }}
                </strong>

                <strong v-else>
                  {{ historyEntry.user.name }}
                </strong>
              </div>
            </li>

            <li class="history-entry__right">
              <dr-icon
                class="history-entry__right-icon ico-calendar"
                :color="'#9B9B9B'"
                :name="'dashCalendar'"
              />

              <div class="history-entry__right-wrapper">
                <span class="history-entry__right-fulldate">
                  {{ historyEntry.date | TO_DATE }}
                </span>

                <!-- <button
                  v-if="'agenda' in historyEntry && historyEntry.agenda.status === 'REALIZADO'"
                  @click="selectedAgenda = historyEntry.agenda; showReceipt = true"
                  class="btn btn-sm btn-primary history-entry__right-button"
                >
                  Ver recibo
                </button> -->
              </div>
            </li>
          </ul>
        </li>
      </ul>
    </transition>
  </main>
</template>

<script>
import printTemplate from '@/components/templates/print/'
import receipt from '@/components/layout/appointments/receipt'

export default {
  props: ['history'],
  components: {
    printTemplate,
    receipt
  },
  data () {
    return {
      historyEntries: [],
      modalActive: null,
      showReceipt: false,
      selectedAgenda: null
    }
  },
  mounted () {
    this.historyEntries = this.historyEntries.concat(this.history)
  },
  watch: {
    history: function (newValue) {
      this.historyEntries = this.historyEntries.concat(this.history)
    },
    showReceipt (value) {
      this.$emit('showReceipt', value)
    }
  }
}
</script>
